import DashboardWidget from '../common/dashboard-widget';
import TopBar from '../common/top-bar';
import List from '../common/list';
import ContributionItem from './item';
import { useEffect, useState } from 'react';
import { useContributions } from './use-contributions';
import { useTranslations } from '@/i18n/use-translations';
import { useNavigate } from 'react-router';
import OrganizationContentStack from '@/components/organization-content-stack';

export default function ContributionsListPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const { contributions, allContributions, isLoading, hasAnyContributions } = useContributions({
    searchTerm,
    useListMode: true,
  });
  const t = useTranslations();
  const navigate = useNavigate();

  useEffect(() => {
    const hasNoFilter = !searchTerm.trim();
    if (!isLoading && hasNoFilter && allContributions.length === 1) {
      navigate(`/contributions/${allContributions[0].id}`, { replace: true });
    }
  }, [isLoading, searchTerm, allContributions, navigate]);

  return (
    <OrganizationContentStack
      content={
        <DashboardWidget
          sx={{
            height: '100%',
            p: 1,
            gap: 0,
            width: '100%',
          }}
          contentSx={{ p: 0 }}
        >
          <TopBar searchTerm={searchTerm} onSearchChange={setSearchTerm} title={t('myEventsList.upcomingEvents')} />
          <List
            items={contributions}
            isLoading={isLoading}
            hasAnyItems={hasAnyContributions}
            getItemKey={(contributor) => contributor.id}
            renderItem={(contributor) => (
              <ContributionItem contributor={contributor} event={contributor.event} isSelected={false} />
            )}
            emptyMessage={t(
              'myEventsList.noContributionsYet',
              undefined,
              'No contributions, yet. Please ask to be invited to contribute to an event with your primary or one of your secondary email addresses. You can add secondary email addresses in your user profile.',
            )}
          />
        </DashboardWidget>
      }
    />
  );
}
